<script setup lang="ts">
import { useAiChatStore } from '@/stores/ai-chat'
import { useAppLayout } from '@/composables/useAppLayout'
import IconButton from '@/components/IconButton.vue'
import { Brain, Menu } from 'lucide-vue-next'

const { pageTitle, openMobileNav } = useAppLayout()
const aiChat = useAiChatStore()
</script>

<template>
  <header
    class="flex shrink-0 items-center gap-2 border-b border-border bg-background px-3 lg:hidden"
    style="height: calc(3rem + env(safe-area-inset-top, 0px)); padding-top: env(safe-area-inset-top, 0px)"
  >
    <IconButton
      size="icon"
      aria-label="Open navigation"
      class="shrink-0"
      @click="openMobileNav"
    >
      <Menu class="size-5" />
    </IconButton>

    <h1 class="min-w-0 flex-1 truncate text-sm font-semibold tracking-tight">
      {{ pageTitle }}
    </h1>

    <IconButton
      size="icon"
      class="relative shrink-0"
      :class="aiChat.sidebarOpen ? 'bg-accent text-foreground' : ''"
      aria-label="Open AI assistant"
      @click="aiChat.toggleSidebar(true)"
    >
      <Brain class="size-5" />
      <span
        v-if="aiChat.isStreaming"
        class="absolute top-1.5 right-1.5 size-2 rounded-full bg-primary"
        aria-hidden="true"
      />
    </IconButton>
  </header>
</template>
